
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface TimePickerProps {
  time: string;
  setTime: (time: string) => void;
  label?: string;
}

export function TimePicker({ time, setTime, label }: TimePickerProps) {
  const [hours, minutes] = time.split(':').map(Number);
  
  const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return;
    
    const newHours = Math.min(Math.max(0, value), 23);
    setTime(`${newHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
  };
  
  const handleMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return;
    
    const newMinutes = Math.min(Math.max(0, value), 59);
    setTime(`${hours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`);
  };
  
  return (
    <div className="grid gap-2">
      {label && <Label>{label}</Label>}
      <div className="flex items-center space-x-2">
        <Input
          type="number"
          value={hours}
          onChange={handleHoursChange}
          min={0}
          max={23}
          className="w-20"
          placeholder="HH"
        />
        <span className="text-xl font-medium">:</span>
        <Input
          type="number"
          value={minutes}
          onChange={handleMinutesChange}
          min={0}
          max={59}
          className="w-20"
          placeholder="MM"
        />
      </div>
    </div>
  );
}
